import { GetterTree } from 'vuex'
import { StoreInterface } from '../index'
import { MessageStateInterface } from 'src/store/message/state'
import { Message } from 'able-lib'

const getters: GetterTree<MessageStateInterface, StoreInterface> = {
  announcementsFromMe: ({ announcements }, getters, rootState) => {
    const userId = rootState.user.user.id
    return announcements.filter(announcement => announcement.senderUser.id === userId)
  },

  getRecentAnnouncements: ({ announcements }: MessageStateInterface) => (maxLength: number): Array<Message> => {
    return [...announcements].slice(0, maxLength || 5)
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  unreadMessageCount: ({ conversationsUnreadMessages }: MessageStateInterface) => (roomIds?: Array<string | number>): number => {
    let count = 0
    for (const unreadMessage of conversationsUnreadMessages) {
      count += unreadMessage.count
    }
    return count
  },

  unreadAnnouncementCount: ({ unreadAnnouncementCount }) => unreadAnnouncementCount

}

export default getters
